import { Injectable, inject } from '@angular/core';
import { PendingOrder, PendingOrderRepository } from '@infrab4a/connect';

@Injectable({
  providedIn: 'root'
})
export class ShopPendingOrderService {
  private pendingOrderRepository = inject<PendingOrderRepository>(
    'PendingOrderRepository' as any
  );

  async findAll(): Promise<PendingOrder[]> {
    return (await this.pendingOrderRepository.find()).data;
  }
}
